import { useEffect, useState } from 'react';
import { FormControl, InputLabel, Grid, MenuItem, Select } from '@mui/material';
import { useApplicationsStore } from '@lib/store';
import { useDebounce } from '@shared/hooks';
import type { ApplicationSearchParams } from '@shared/api';
import { Input } from '@shared/widgets';
import { CustomDatePicker } from './CustomDatePicker';

const STATUSES = ['Draft', 'IppCreditAuthority', 'InProgress', 'Complete', 'Rejected'];

export const ApplicationSearchForm = () => {
  const { getApplications } = useApplicationsStore();

  const [filters, setFilters] = useState<ApplicationSearchParams>({});
  const debouncedFilters = useDebounce(filters);

  useEffect(() => {
    getApplications(debouncedFilters);
  }, [debouncedFilters]);

  return (
    <form>
      <Grid container>
        <Grid item xs={12}>
          <Input
            name='ApplicationName'
            label='Application Ref №'
            value={filters.ApplicationName || ''}
            onChange={(e) => setFilters((prev) => ({ ...prev, ApplicationName: e.target.value }))}
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            name='Passport'
            label='Passport / ID Card Number'
            value={filters.Passport || ''}
            onChange={(e) => setFilters((prev) => ({ ...prev, Passport: e.target.value }))}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <InputLabel>Status</InputLabel>
            <Select
              variant='standard'
              name='Status'
              label='Status'
              fullWidth
              value={filters.status || ''}
              onChange={(e) => setFilters((prev) => ({ ...prev, status: e.target.value }))}
            >
              {filters.status && (
                <MenuItem>
                  <em>Clear</em>
                </MenuItem>
              )}
              {STATUSES.map((item) => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <CustomDatePicker
            name='ModifiedOn'
            label='Last Updated'
            inputFormat='dd/MM/yyyy'
            fullWidth
            validate
            value={filters.ModifiedOn || null}
            onChange={(value) => setFilters((prev) => ({ ...prev, ModifiedOn: value! }))}
          />
        </Grid>
      </Grid>
    </form>
  );
};
